// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__kcqdB"};